import ShieldFilledIcon from './ShieldFilledIcon'

export default ShieldFilledIcon
